<script setup>
  import i18n from '@/lang/i18n';
  import { MANUAL_LINK } from '@/services/consts'

  const props = defineProps({
    pageName: { type: String }
  })

  function moveLinks () {
    return MANUAL_LINK[props.pageName] || process.env.VUE_APP_SUPPORT_LINK
  }
</script>

<template>
  <a
    :href="moveLinks()"
    target="_blank"
  >
    <v-tooltip
      location="bottom"
      :open-delay="500"
    >
      <template #activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          class="help-btn"
          width="32"
          height="32"
          rounded="circle"
        >
          <div class="d-flex flex-column align-center justify-center">
            <span class="material-symbols-outlined" style="font-size: 16px;">
              question_mark
            </span>
          </div>
        </v-btn>
      </template>
      {{ i18n.global.t('pages.common.help.title') }}
    </v-tooltip>
  </a>
</template>

<style scoped>
.help-btn {
  background-color: rgb(21, 130, 156);
  color: white;
  z-index: 999;
  min-width: 0;
}
</style>
